import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent, PageSettingsModel, RowDataBoundEventArgs, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { Data, Router } from '@angular/router';
import { DataManager, WebApiAdaptor, Query } from '@syncfusion/ej2-data';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SharedFunctions } from '../../../shared/shared.functions';
import { EventEmiterService } from '../../../../../src/app/shared/services/event-emiter.service';

import { MenuFuncionService, MovimientoService } from '../../../shared/services/index';
import { SearchResumenCajaRequestDto, GridPageSettings, LocalStorageKeys, MenuFuncionCodes, DialogDetalleMovimientosConsolidadoCajaRequestDto, ReporteConsolidadoCajaAgrupadorConstants } from '../../../shared/model';
import { DialogDetalleMovimientosConsolidadoCajaComponent } from '../../reportes/reporte-consolidado-caja/components/dialogDetalleMovimientosConsolidadoCaja.component';


@Component({
    selector: 'app-resumenCaja',
    templateUrl: './resumenCaja.component.html',
    styleUrls: ['./resumenCaja.component.scss']
})

export class ResumenCajaComponent implements OnInit{

  @ViewChild('grid')
  public grid: GridComponent;

  search = new SearchResumenCajaRequestDto(null,null,false,null,null,false); 
  isValidating: boolean = false;
  canView: boolean = false; 
  isSearching: boolean = false;
  isStatisticsSearching: boolean = false;

  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;
  searchForm: FormGroup;
  public data: DataManager;
  public query: Query;

  private subscription: Subscription;
  isRosbaco: boolean;

  constructor(
    private sharedFunctions: SharedFunctions,
    private movimientoService: MovimientoService,
    private menuService: MenuFuncionService,
    private router: Router,
    private eventEmitterService: EventEmiterService,
    private formBuilder: FormBuilder,
    public dialog: MatDialog
  ) { 
    this.subscription = this.eventEmitterService.reloadView$.subscribe((value) => {
      this.loadView()
    });
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenu(MenuFuncionCodes.DASHBOARD_CAJA_CHICA).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result){
        this.canView = true;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList ;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    

    this.setQueryParams();

    this.data = new DataManager({
      url: this.movimientoService.getServiceUrl() + '/dashboard-resumen-caja',
      adaptor: new WebApiAdaptor(),
      headers: [this.movimientoService.getAuthorizationHeader(),this.movimientoService.getTenantHeader()]
    });
    this.buildForm();

  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);
      
    var index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = cId;
    else
      this.query.addParams("ConsorcioId", cId);
  }

  getTraduccion(value: string) {
    return this.sharedFunctions.getNombreMenuTenant(value);
  }

  rowDataBound(args: RowDataBoundEventArgs) {
    if (args?.data != null) {
      let resumenCajaValue:any = args.data.valueOf()
      if (resumenCajaValue.SuperoPuntoEquilibrio == true) {
        args.row?.classList.add('ok');
      } 
      else {
        args.row?.classList.add('critical');
      }
    }
  }
  buildForm(){
    var fechaHoy = new Date();
    this.isRosbaco = this.sharedFunctions.isRosbacoUser();

    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    this.searchForm = this.formBuilder.group({
      'CampoAgrupador': [this.isRosbaco ? ReporteConsolidadoCajaAgrupadorConstants.Comunidad : ReporteConsolidadoCajaAgrupadorConstants.Tenant],
      'MonedaConversionId': [null],
      'Proveedor': [null],
      'ComunidadId': [null],
      'ConsorcioId': [cId],
      'UnidadFuncionalId': [null],
      'PersonaId': [null],
      'MonedaId': [null],
      'FechaDesde': [null],
      'FechaHasta': [null],
      'FechaVencimientoDesde': [null],
      'FechaVencimientoHasta': [new Date(fechaHoy.getFullYear(), fechaHoy.getMonth() + 1, 0)],
      'DescartarPendientes': [null],
      'VerBalancesNoCero': [null]
    });
  }
 
  openDialogDetalleMovimientos(item: any) {
    this.searchForm.get('ComunidadId')?.setValue(item.ComunidadId);
    this.searchForm.get('MonedaId')?.setValue(item.MonedaId);

    var request = this.searchForm.getRawValue();
    console.log("antes",request)
    request.MonedaId = item.MonedaOriginalId;

    // switch (request.CampoAgrupador)
    // {
    //   case ReporteConsolidadoCajaAgrupadorConstants.Tenant:
    //     break;
    //   case ReporteConsolidadoCajaAgrupadorConstants.Comunidad:
    //     request.ComunidadId = item.ConceptoId;
    //     break;
    //   case ReporteConsolidadoCajaAgrupadorConstants.Consorcio:
    //     request.ConsorcioId = item.ConceptoId;
    //     break;
    //   case ReporteConsolidadoCajaAgrupadorConstants.Proveedor:
    //     request.ProveedorId = item.ConceptoId;
    //     break;
    //   case ReporteConsolidadoCajaAgrupadorConstants.Persona:
    //     request.PersonaId = item.ConceptoId;
    //     break;
    //   case ReporteConsolidadoCajaAgrupadorConstants.UnidadFuncional:
    //     request.UnidadFuncionalId = item.ConceptoId;
    //     break;
    // }

    console.log("todo home caja chica item",item)
    console.log("todo home caja chica request",request)

    const dialogRef = this.dialog.open(DialogDetalleMovimientosConsolidadoCajaComponent, {
      data: new DialogDetalleMovimientosConsolidadoCajaRequestDto(request, item)
    });

    dialogRef.afterClosed().subscribe((result: any) => {
    });
  }


  irMovimientoView() {
    this.router.navigate(['movimiento-edit/0']);
  }
}